import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ICtoContract } from '../../core/models/cto.model';
import { CtoApiService } from '../../core/modules/cto/cto-api.service';

interface IStatus {
  id: number;
  name: string;
  isSelected: boolean;
  counter?: number;
}

@Component({
  selector: 'tax-cto',
  templateUrl: './cto.component.html',
  styleUrls: ['./cto.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class CtoComponent implements OnInit, OnDestroy {
  // @ts-ignore
  private subscription: Subscription;
  // @ts-ignore
  fullContractsList: Array<ICtoContract>;
  // @ts-ignore
  filteredContractsList: Array<ICtoContract>;
  statuses: Array<IStatus> = [
    {
      id: 1, name: 'waiting', isSelected: false,
    },
    {
      id: 2, name: 'active', isSelected: false,
    },
    {
      id: 3, name: 'rejected', isSelected: false,
    },
    {
      id: 4, name: 'annulated', isSelected: false,
    },
    {
      id: 7, name: 'closed', isSelected: false,
    },
    {
      id: 6, name: 'terminated', isSelected: false,
    },
    {
      id: 5, name: 'terminated.requested', isSelected: false,
    },
    {
      id: -1, name: 'unknown', isSelected: false,
    },
  ];

  constructor(
    private ctoApiService: CtoApiService,
    private changeDetector: ChangeDetectorRef,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.subscription = this.ctoApiService.fetchContracts().subscribe(
      (response: Array<ICtoContract>) => this.fullContractsList = response,
      (error: unknown) => {},
      () => {
        this.changeDetector.markForCheck();
        this.filteredContractsList = Object.assign(this.fullContractsList);
        this.statuses.map(
          (status: IStatus) => {
            status.counter = this.calculateStatusCounter(this.fullContractsList, status.id);
          },
        );
      },
    );
  }

  calculateStatusCounter(ctoContracts: Array<ICtoContract>, statusId: number): number {
    return ctoContracts.reduce((counter: number, contract: ICtoContract) => {
      if (contract.status === statusId) {
        counter++;
      }
      return counter;
    }, 0);
  }

  filterContracts(statusId: number): void {
    const selectedStatusIds: Array<number> = this.statuses.reduce((result: Array<number>, status: IStatus) => {
      if (status.id === statusId) {
        status.isSelected = !status.isSelected;
      }
      if (status.isSelected) {
        result.push(status.id);
      }
      return result;
    }, []);
    this.filteredContractsList = this.fullContractsList.filter(
      (contract: ICtoContract) => selectedStatusIds.includes(contract.status),
    );
    if (!selectedStatusIds.length) {
      this.filteredContractsList = Object.assign(this.fullContractsList);
    }
  }

  goToCtoDetails(id: number): void {
    this.router.navigate(['main/cto', id]);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
